module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Swiper_COM")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "100",
      "src": "http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fswiper"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("演示")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "377px",
      "height": "667px",
      "display": "inline-block",
      "border": "1px dashed #ececec",
      "border-radius": "5px",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux.li/demos/v2/#/component/swiper",
      "width": "375",
      "height": "667",
      "border": "0",
      "frameborder": "0"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("demo 代码")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h4', [_vm._v("Github Issue")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "font-size": "12px",
      "color": "#888"
    },
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/swiper",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接：https://vux.li/demos/v2/#/component/swiper")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("THX to: https://github.com/wechatui/swiper"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("list模式下，默认高度为180px, 如果设置aspect-ratio会根据宽度自动计算高度"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_index\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_onIndexChange\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"copyright\"")]), _vm._v(">")]), _vm._v("Image Source: http://www.gratisography.com/"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("current index: "), _c('span', [_vm._v("{{")]), _vm._v("demo01_index"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_index = 0\"")]), _vm._v(">")]), _vm._v("go to 0"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_index = 1\"")]), _vm._v(">")]), _vm._v("go to 1"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_index = 2\"")]), _vm._v(">")]), _vm._v("go to 2"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo02_index\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo01_onIndexChange\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("设置aspect-ratio, 将自动根据宽度计算高度"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo02_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width:85%;margin:0 auto;\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":aspect-ratio")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"300/800\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("dots-position")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"center\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("自动轮播"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo03_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width:80%;margin:0 auto;\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"180px\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("dots-class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"custom-bottom\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("dots-position")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"center\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("use swiper-item for image list"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":aspect-ratio")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"300/800\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiper-demo-img\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-for")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"(item, index) in demo04_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":key")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"index\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("img")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"item\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("set index = 1 with swiper-item"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":aspect-ratio")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"300/800\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"onSwiperItemIndexChange\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiperItemIndex\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiper-demo-img\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-for")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"(item, index) in demo04_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":key")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"index\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("img")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"item\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', [_vm._v("{{")]), _vm._v(" swiperItemIndex "), _c('span', [_vm._v("}}")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiperItemIndex = 0\"")]), _vm._v(">")]), _vm._v("go to 0"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiperItemIndex = 1\"")]), _vm._v(">")]), _vm._v("go to 1"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"swiperItemIndex = 2\"")]), _vm._v(">")]), _vm._v("go to 2"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("Async setting list data"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo05_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"180px\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo05_onIndexChange\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v(" current index: "), _c('span', [_vm._v("{{")]), _vm._v("demo05_index"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo05_onLoad(1)\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"primary\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"margin: 10px 0;\"")]), _vm._v(">")]), _vm._v("Load list1"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo05_onLoad(2)\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("type")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"primary\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"margin: 10px 0;\"")]), _vm._v(">")]), _vm._v("Load list2"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-button")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("引入swiper-item自定义item内容，用height定义高度"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"100px\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("它无孔不入"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("你无处可藏"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("不是它可恶"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("而是它不懂你"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("我们试图"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"black\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"title fadeInUp animated\"")]), _vm._v(">")]), _vm._v("做些改变"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("h2")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("垂直方向文字滚动"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"30px\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("direction")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vertical\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":interval")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("2000")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"text-scroll\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":show-dots")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"false\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("义务爱了 完成传奇世界H5-王者归来任务 获得20金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("基本世神 兑换《传奇世界H5》畅玩级礼包 消耗30金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("零哥章魚 完成传奇世界H5-王者归来任务 获得30金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("做迎而為 兑换【饿了么】畅享美食红包 消耗20金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("只知道不知道 兑换【饿了么】畅享美食红包 消耗20金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("基本世神 兑换《传奇世界H5》畅玩级礼包 消耗30金币"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper-item")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("华丽的分割线"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("循环模式"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loop")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo06_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":index")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo06_index\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo06_onIndexChange\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("current index: "), _c('span', [_vm._v("{{")]), _vm._v("demo06_index"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("\n\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("循环模式（只有两个且可点击）"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group-title")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loop")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("auto")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":list")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo07_list\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":index")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo07_index\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("@on-index-change")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo07_onIndexChange\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("swiper")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("current index: "), _c('span', [_vm._v("{{")]), _vm._v("demo07_index"), _c('span', [_vm._v("}}")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("p")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Swiper, GroupTitle, SwiperItem, XButton, Divider } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" baseList = [{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'javascript:'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://static.vux.li/demo/1.jpg'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'送你一朵fua'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'javascript:'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://static.vux.li/demo/2.jpg'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'送你一辆车'")]), _vm._v("\n}, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'javascript:'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://static.vux.li/demo/5.jpg'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'送你一次旅行'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fallbackImg")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://static.vux.li/demo/3.jpg'")]), _vm._v("\n}]\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" imgList = [\n  "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://placeholder.qiniudn.com/800x300/FF3B3B/ffffff'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://placeholder.qiniudn.com/800x300/FFEF7D/ffffff'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://placeholder.qiniudn.com/800x300/8AEEB1/ffffff'")]), _vm._v("\n]\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" urlList = baseList.map("), _c('span', {
    staticClass: "hljs-function"
  }, [_vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("item, index")]), _vm._v(") =>")]), _vm._v(" ({\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://m.baidu.com'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": item.img,\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fallbackImg")]), _vm._v(": item.fallbackImg,\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("`(可点击)"), _c('span', {
    staticClass: "hljs-subst"
  }, [_vm._v("${item.title}")]), _vm._v("`")]), _vm._v("\n}))\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" demoList = imgList.map("), _c('span', {
    staticClass: "hljs-function"
  }, [_vm._v("("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("one, index")]), _vm._v(") =>")]), _vm._v(" ({\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("url")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'javascript:'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": one\n}))\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" only2ClickList = baseList.slice("), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2")]), _vm._v(").map("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("item")]), _vm._v(" =>")]), _vm._v(" {\n  item.url = "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'http://m.baidu.com'")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" item\n})\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Swiper,\n    SwiperItem,\n    GroupTitle,\n    XButton,\n    Divider\n  },\n  ready () {\n\n  },\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("methods")]), _vm._v(": {\n    onSwiperItemIndexChange (index) {\n      "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'demo item change'")]), _vm._v(", index)\n    },\n    demo01_onIndexChange (index) {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".demo01_index = index\n    },\n    demo05_onIndexChange (index) {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".demo05_index = index\n    },\n    demo05_onLoad (id) {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".demo05_list = id === "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(" ? baseList : demoList\n    },\n    demo06_onIndexChange (index) {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".demo06_index = index\n    },\n    demo07_onIndexChange (index) {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".demo07_index = index\n    }\n  },\n  data () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo01_list")]), _vm._v(": baseList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo02_list")]), _vm._v(": demoList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo03_list")]), _vm._v(": demoList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo04_list")]), _vm._v(": imgList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo05_list")]), _vm._v(": [],\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo06_list")]), _vm._v(": urlList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo07_list")]), _vm._v(": only2ClickList,\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo01_index")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo02_index")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo05_index")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo06_index")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("demo07_index")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(",\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("swiperItemIndex")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1")]), _vm._v("\n    }\n  }\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scoped")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n.copyright {\n  font-size: 12px;\n  color: #ccc;\n  text-align: center;\n}\n.text-scroll {\n  border: 1px solid #ddd;\n  border-left: none;\n  border-right: none;\n}\n.text-scroll p{\n  font-size: 12px;\n  text-align: center;\n  line-height: 30px;\n}\n.black {\n  background-color: #000;\n}\n.title{\n  line-height: 100px;\n  text-align: center;\n  color: #fff;\n}\n.animated {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n.vux-indicator.custom-bottom {\n  bottom: 30px;\n}\n@-webkit-keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.fadeInUp {\n  animation-name: fadeInUp;\n}\n.swiper-demo-img img {\n  width: 100%;\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n\n")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c4ba9f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-6c4ba9f2"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/swiper-411.vue
// module id = 2837
// module chunks = 479